import React from 'react';
import { Popover, OverlayTrigger, List, ListItem, Button } from '@deere/ux.uxframe-react';
import { SVGIcon } from './SVGIcon';
import { NO_CONTACTS } from '../utils/surveyLiterals'

export const Contacts = ( {items, isNonDeere} ) => {

    const popOver = () => {
        return <div className="uxf-popover-title">
            <span className="mr-2 font-weight-bold">{'Deere Contacts'}</span>
            <span>{ items[0] }</span>
            <OverlayTrigger placement="bottom" trigger="click" overlay={<Popover id="popover-example">
                        <Popover.Content>
                            <List variant="uxf-ul">
                                {
                                    items.map( ( item, indx ) => indx !== 0 ? <ListItem key={indx}>{ item }</ListItem> : null)
                                }
                            </List>
                        </Popover.Content>
                    </Popover>}>
                <Button variant="uxf-icon" className="btn-uxf-icon-no-hover">
                    <SVGIcon />
                </Button>
            </OverlayTrigger>
        </div>
    }

    const isModal = () => {
        if(items === undefined || items === null) {
            return <><span className="mr-2 font-weight-bold">{isNonDeere ? 'Company Contact' : 'Deere Contact'}</span><span>{NO_CONTACTS}</span></>
        }
        
        if( items.length === 1 ) {
            return <><span className="mr-2 font-weight-bold">{isNonDeere ? 'Company Contact' : 'Deere Contact'}</span><span>{items}</span></>;
        } else if( items.length >= 2 ) {
            return popOver();
        } 

        return <><span className="mr-2 font-weight-bold">{isNonDeere ? 'Company Contact' : 'Deere Contact'}</span><span>{NO_CONTACTS}</span></>
    };
    
    return isModal();
}
